import * as allActions from "../actions.constants";

//search data 
export function receiveTagData(data) {
  return {
    type: allActions.RECIEVE_TAG_DATA,
    payload: data
  };
}

export function fetchTagData() {
  return {
    type: allActions.FETCH_TAG_DATA,
  };
}

export function receiveAsksData(data) {
  return {
    type: allActions.RECIEVE_ASKS_DATA,
    payload: data
  };
}

export function fetchAsksData() {
  return {
    type: allActions.FETCH_ASKS_DATA,
  };
}